<template>
  <div>
    <div @click="routerTo()" id="tb3" style="width: 100%; height: 350px"></div>
  </div>
</template>

<script>
export default {
  props: ["rcxx", "isTrue"],
  data() {
    return {};
  },
  watch: {
    isTrue(val) {
      if (val == true) {
        this.getJrqk();
      }
    },
  },
  methods: {
    routerTo() {
      this.$router.push({ path: "/index/apartment/personnelInformation" });
    },
    getJrqk() {
      let myChart = this.echarts.init(document.getElementById("tb3"), "dark");
      setTimeout(() => {
        this.$http.get("/api/checkInApply/countTalentByLevel").then((res) => {
          let data = [
            {
              value: res.data.data.undergraduate,
              name: "本科",
            },
            {
              value: res.data.data.master,
              name: "硕士",
            },
            {
              value: res.data.data.doctor,
              name: "博士",
            },
            {
              value: res.data.data.expert,
              name: "专家",
            },
            {
              value: res.data.data.returnees,
              name: "海归",
            },
          ];
          let option = {
            backgroundColor: "#0F0B26",
            title: {
              text: "人才统计",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c}",
            },
            color: ["#8D48E3", "#4992FF", "#FF8A45", "#05C091", "#7CFFB2"],
            legend: {
              x: "center",
              y: "bottom",
              data: ["本科", "硕士", "博士", "专家", "海归"],
            },
            series: [
              {
                name: "人才信息",
                type: "pie",
                radius: "50%",
                data: data,
                avoidLabelOverlap: true, //图饼标签false重复
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      formatter: "{b} : {c} ",
                    },
                    labelLine: {
                      show: true,
                    },
                  },
                },
              },
            ],
          };
          myChart.setOption(option);
        });
      }, 100);
    },
  },
};
</script>

<style scoped="scoped"></style>
